<template>
  <div class="flex animate-pulse flex-col">
    <div class="previews-grid grid gap-2 overflow-hidden md:!flex md:px-3">
      <div
        v-for="i in 3"
        :key="i"
        class="overflow-hidden rounded md:rounded-none lg:w-1/2"
        :class="[{ 'row-span-2': i === 1 }, roundedPreviews[i - 1]]"
        :style="{ aspectRatio: aspectRatio.threePreviewsList[i - 1] }"
      >
        <div class="size-full bg-secondary md:rounded-lg lg:h-[440px]" />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { useGalleryPreview } from '@/5_entities/Event'

const { aspectRatio, roundedPreviews } = useGalleryPreview()
</script>

<style scoped>
.previews-grid {
  display: grid;
  grid-template-columns: 2.39fr 1fr;
  grid-template-rows: 1fr 1fr;
}
</style>
